import { ActionIcon, Menu } from '@mantine/core';
import { IconCheck, IconDeviceDesktop, IconMoon, IconSun } from '@tabler/icons-react';
import { useCustomerAppearance } from '@/hooks/useCustomerAppearance';

export function CustomerAppearanceMenu() {
  const { preference, setPreference, colorScheme } = useCustomerAppearance();
  const label = preference === 'auto' ? 'System' : preference === 'dark' ? 'Dark' : 'Light';

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <ActionIcon variant="default" size={44} radius="md" aria-label={`Appearance: ${label}`} title="Change appearance">
          {colorScheme === 'dark' ? <IconMoon size={19} /> : <IconSun size={19} />}
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Appearance</Menu.Label>
        {([
          { value: 'light', label: 'Light', icon: IconSun },
          { value: 'dark', label: 'Dark', icon: IconMoon },
          { value: 'auto', label: 'Use system setting', icon: IconDeviceDesktop },
        ] as const).map(({ value, label, icon: Icon }) => (
          <Menu.Item key={value} aria-current={preference === value ? true : undefined}
            leftSection={<Icon size={17} aria-hidden />} rightSection={preference === value ? <IconCheck size={16} aria-hidden /> : null}
            onClick={() => setPreference(value)}>
            {label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
